/**
 * Module front PUR (sans jQuery ni DOM) — règles de format des identifiants de connexion (numéro de
 * dossier, numéro tiers), extraites à l'identique et dédupliquées entre `connexion.js` et
 * `connexion_borne.js` (bloc byte-identique dans les 2 fichiers).
 *
 * Distinct de modules/file-number.js (isTemporaryFileNumber, préfixe T/D) : regex différente (celle-ci
 * valide la FORME complète du numéro de dossier saisi à la connexion, pas seulement son préfixe) —
 * non fusionné pour ne rien changer au comportement.
 *
 * CommonJS (require/module.exports) pour être exécutable par Jest sans transpilation ; consommable par Webpack.
 */
'use strict';

var FILE_NUMBER_PATTERN = /^[T|D]([a-zA-Z0-9_-]){8}$/;
var NUMBER_TIER_PATTERN = /^.+$/;

function isValidFileNumber(value) {
    return FILE_NUMBER_PATTERN.test(value);
}

function isValidNumberTier(value) {
    return NUMBER_TIER_PATTERN.test(value);
}

module.exports = {
    FILE_NUMBER_PATTERN: FILE_NUMBER_PATTERN,
    NUMBER_TIER_PATTERN: NUMBER_TIER_PATTERN,
    isValidFileNumber: isValidFileNumber,
    isValidNumberTier: isValidNumberTier
};
